export default function isUserStaff() {
  return sessionStorage.getItem("isStaff") === "true";
}
